import { render, staticRenderFns } from "./MaydayDiagnosticMessageEditor.vue?vue&type=template&id=508676c6&scoped=true&"
import script from "./MaydayDiagnosticMessageEditor.vue?vue&type=script&lang=js&"
export * from "./MaydayDiagnosticMessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./MaydayDiagnosticMessageEditor.vue?vue&type=style&index=0&id=508676c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508676c6",
  null
  
)

export default component.exports